import styled from 'styled-components';

export const StyledCategoriesListUl = styled.ul`
    list-style-type: none;
`;

export const StyledDivider = styled.hr`
    border: 1px solid rgba(255, 255, 255, 0.3);
`;
